var RichTextNodeType;

(function (RichTextNodeType2) {
  RichTextNodeType2["heading1"] = "heading1";
  RichTextNodeType2["heading2"] = "heading2";
  RichTextNodeType2["heading3"] = "heading3";
  RichTextNodeType2["heading4"] = "heading4";
  RichTextNodeType2["heading5"] = "heading5";
  RichTextNodeType2["heading6"] = "heading6";
  RichTextNodeType2["paragraph"] = "paragraph";
  RichTextNodeType2["preformatted"] = "preformatted";
  RichTextNodeType2["strong"] = "strong";
  RichTextNodeType2["em"] = "em";
  RichTextNodeType2["listItem"] = "list-item";
  RichTextNodeType2["oListItem"] = "o-list-item";
  RichTextNodeType2["list"] = "group-list-item";
  RichTextNodeType2["oList"] = "group-o-list-item";
  RichTextNodeType2["image"] = "image";
  RichTextNodeType2["embed"] = "embed";
  RichTextNodeType2["hyperlink"] = "hyperlink";
  RichTextNodeType2["label"] = "label";
  RichTextNodeType2["span"] = "span";
})(RichTextNodeType || (RichTextNodeType = {}));

var LinkType;

(function (LinkType2) {
  LinkType2["Any"] = "Any";
  LinkType2["Document"] = "Document";
  LinkType2["Media"] = "Media";
  LinkType2["Web"] = "Web";
})(LinkType || (LinkType = {}));

var EmbedType;

(function (EmbedType2) {
  EmbedType2["Link"] = "link";
  EmbedType2["Rich"] = "rich";
})(EmbedType || (EmbedType = {}));

var CustomTypeModelFieldType;

(function (CustomTypeModelFieldType2) {
  CustomTypeModelFieldType2["Boolean"] = "Boolean";
  CustomTypeModelFieldType2["Color"] = "Color";
  CustomTypeModelFieldType2["Date"] = "Date";
  CustomTypeModelFieldType2["Embed"] = "Embed";
  CustomTypeModelFieldType2["GeoPoint"] = "GeoPoint";
  CustomTypeModelFieldType2["Group"] = "Group";
  CustomTypeModelFieldType2["Image"] = "Image";
  CustomTypeModelFieldType2["IntegrationFields"] = "IntegrationFields";
  CustomTypeModelFieldType2["Link"] = "Link";
  CustomTypeModelFieldType2["Number"] = "Number";
  CustomTypeModelFieldType2["Select"] = "Select";
  CustomTypeModelFieldType2["Slices"] = "Slices";
  CustomTypeModelFieldType2["StructuredText"] = "StructuredText";
  CustomTypeModelFieldType2["Text"] = "Text";
  CustomTypeModelFieldType2["Timestamp"] = "Timestamp";
  CustomTypeModelFieldType2["UID"] = "UID";
})(CustomTypeModelFieldType || (CustomTypeModelFieldType = {}));

var CustomTypeModelLinkSelectType;

(function (CustomTypeModelLinkSelectType2) {
  CustomTypeModelLinkSelectType2["Document"] = "document";
  CustomTypeModelLinkSelectType2["Media"] = "media";
})(CustomTypeModelLinkSelectType || (CustomTypeModelLinkSelectType = {}));

var CustomTypeModelSliceDisplay;

(function (CustomTypeModelSliceDisplay2) {
  CustomTypeModelSliceDisplay2["List"] = "list";
  CustomTypeModelSliceDisplay2["Grid"] = "grid";
})(CustomTypeModelSliceDisplay || (CustomTypeModelSliceDisplay = {}));

var CustomTypeModelSliceType;

(function (CustomTypeModelSliceType2) {
  CustomTypeModelSliceType2["Slice"] = "Slice";
  CustomTypeModelSliceType2["SharedSlice"] = "SharedSlice";
})(CustomTypeModelSliceType || (CustomTypeModelSliceType = {}));

export { CustomTypeModelFieldType, CustomTypeModelLinkSelectType, CustomTypeModelSliceDisplay, CustomTypeModelSliceType, EmbedType, LinkType, RichTextNodeType };